function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
//const Slip = require("../../lib/saito/slip").default;
var PeerService = require('saito-js/lib/peer_service')["default"];
var Transaction = require('../../lib/saito/transaction')["default"];
var ModTemplate = require('../../lib/templates/modtemplate');
//var saito = require("../../lib/saito/saito");
var JSON = require('json-bigint');

/**
 *
 * Relay is a utility for sending offchain messages
 *
 * If you just want to send a tx, pass it as a parameter to the event "relay-transaction"
 *
 * Otherwise, you can send arbitrary data and a request to specified recipients through "relay-send-message",
 * that will wrap your data in a relay transaction. Your module will need to listen for the given request
 * in it's handlePeerTransaction function.
 *
 */
var Relay = /*#__PURE__*/function (_ModTemplate) {
  function Relay(app) {
    var _this;
    _classCallCheck(this, Relay);
    _this = _callSuper(this, Relay, [app]);
    _this.app = app;
    _this.name = 'Relay';
    _this.slug = 'relay';
    _this.description = 'Adds support for off-chain, realtime communications channels through relay servers, for mobile users and real-time gaming needs.';
    _this.categories = 'Utilities Core';
    _this["class"] = 'utility';
    _this.description = 'Simple Message Relay for Saito';
    _this.categories = 'Utilities Communications';
    _this.debug = false;
    _this.busy = false;
    _this.stun = null;
    app.connection.on('relay-send-message', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.sendRelayMessage(obj.recipient, obj.request, obj.data);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    app.connection.on('relay-transaction', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(tx) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this.sendRelayTransaction(tx);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    app.connection.on('set-relay-status-to-busy', function () {
      _this.busy = true;
    });
    app.connection.on('relay-ping-peer', function (public_keys) {
      _this.sendRelayMessage(public_keys, 'ping', {
        status: _this.busy
      });
    });
    app.connection.on('relay-notify-peer', function (publicKeys, data) {
      _this.sendRelayMessage(publicKeys, 'notify', data);
    });
    return _this;
  }
  _inherits(Relay, _ModTemplate);
  return _createClass(Relay, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var modList;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _superPropGet(Relay, "initialize", this, 3)([app]);
            case 1:
              modList = this.app.modules.returnModulesRespondingTo('peer-manager');
              if (modList.length > 0) {
                this.stun = modList[0].respondTo('peer-manager');
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function initialize(_x3) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      services.push(new PeerService(null, 'relay'));
      return services;
    }
  }, {
    key: "createRelayTransaction",
    value: function () {
      var _createRelayTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(recipients, message_request, message_data) {
        var peers, p, i, tx, _i;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              peers = [];
              if (!(recipients === 'PEERS')) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this.app.network.getPeers();
            case 1:
              p = _context4.v;
              for (i = 0; i < p.length; i++) {
                peers.push(p[i].publicKey);
              }
              _context4.n = 3;
              break;
            case 2:
              if (!Array.isArray(recipients)) {
                peers.push(recipients);
              } else {
                peers = recipients;
              }
            case 3:
              tx = new Transaction();
              tx.addFrom(this.publicKey);
              for (_i = 0; _i < peers.length; _i++) {
                tx.addTo(peers[_i]);
              }
              tx.timestamp = new Date().getTime();
              tx.msg.module = 'Relay';
              tx.msg.request = message_request;
              tx.msg.data = message_data;

              // Should we sign the transaction???
              // I ask because the code didn't originally sign it...
              return _context4.a(2, tx);
          }
        }, _callee4, this);
      }));
      function createRelayTransaction(_x4, _x5, _x6) {
        return _createRelayTransaction.apply(this, arguments);
      }
      return createRelayTransaction;
    }()
  }, {
    key: "sendRelayTransaction",
    value: function () {
      var _sendRelayTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(tx) {
        var need_server, i, addressee, peers, _i2, _peers$_i;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              need_server = true;
              if (this.stun) {
                need_server = false;
                for (i = 0; i < tx.to.length; i++) {
                  addressee = tx.to[i].publicKey;
                  if (addressee !== this.publicKey) {
                    if (this.stun.hasConnection(addressee)) {
                      this.stun.sendTransaction(addressee, tx);
                    } else {
                      //console.log("Need to use Relay server because no stun connection with " + addressee);
                      need_server = true;
                    }
                  }
                }
                if (!need_server && tx.isTo(this.publicKey)) {
                  // We won't send tx through relay service
                  // but should make sure we process it ourselves as if it was coming in
                  this.app.modules.handlePeerTransaction(tx);
                }
              }
              if (!need_server) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return this.app.network.getPeers();
            case 1:
              peers = _context5.v;
              for (_i2 = 0; _i2 < peers.length; _i2++) {
                if (((_peers$_i = peers[_i2]) === null || _peers$_i === void 0 ? void 0 : _peers$_i.status) !== 'disconnected') {
                  // *** NOTE ***
                  // tx.msg.data is a json-ready transaction
                  // this network function wraps the whole thing within another transaction
                  // newtx.msg.data.msg.data = original transactionn
                  this.app.network.sendRequestAsTransaction('relay peer message', tx.toJson(), null, peers[_i2].publicKey);
                }
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function sendRelayTransaction(_x7) {
        return _sendRelayTransaction.apply(this, arguments);
      }
      return sendRelayTransaction;
    }() //
    // currently a 1-hop function, should abstract to take an array of
    // recipients and permit multi-hop transaction construction.
    //
  }, {
    key: "sendRelayMessage",
    value: function () {
      var _sendRelayMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(recipients, message_request, message_data) {
        var newtx;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(!recipients || !message_request)) {
                _context6.n = 1;
                break;
              }
              console.warn('Invalid relay message:', recipients, message_request, message_data);
              return _context6.a(2);
            case 1:
              _context6.n = 2;
              return this.createRelayTransaction(recipients, message_request, message_data);
            case 2:
              newtx = _context6.v;
              _context6.n = 3;
              return this.sendRelayTransaction(newtx);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function sendRelayMessage(_x8, _x9, _x0) {
        return _sendRelayMessage.apply(this, arguments);
      }
      return sendRelayMessage;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(app) {
        var tx,
          peer,
          mycallback,
          message,
          _this$stun,
          _relayed_tx$to$,
          relayed_tx,
          txjson,
          peer_found,
          peers,
          i,
          _args8 = arguments,
          _t;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              tx = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
              peer = _args8.length > 2 ? _args8[2] : undefined;
              mycallback = _args8.length > 3 ? _args8[3] : undefined;
              if (!(tx == null)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, 0);
            case 1:
              message = tx.returnMessage();
              _context8.p = 2;
              if (!tx.isTo(this.publicKey)) {
                _context8.n = 5;
                break;
              }
              if (!(message.request === 'echo' || message.request === 'ping')) {
                _context8.n = 4;
                break;
              }
              if (message.data.status) {
                app.connection.emit('relay-is-busy', tx.from[0].publicKey);
              } else {
                app.connection.emit('relay-is-online', tx.from[0].publicKey, (_this$stun = this.stun) === null || _this$stun === void 0 ? void 0 : _this$stun.hasConnection(tx.from[0].publicKey));
              }
              if (!(message.request === 'ping')) {
                _context8.n = 3;
                break;
              }
              _context8.n = 3;
              return this.sendRelayMessage(tx.from[0].publicKey, 'echo', {
                status: this.busy
              });
            case 3:
              return _context8.a(2, 0);
            case 4:
              if (message.request === 'notify') {
                /*
                  Should probably add processing in modtemplate and gametemplate (and double check that all mods
                  include super.handlePeerTransaction)... but for now, the relay-notification event is only picked 
                  up by the gametemplate so we can get away with this...
                */

                app.connection.emit('relay-notification', message.data);

                //return app.modules.handlePeerTransaction(relayed_tx, peer, mycallback);
              }
            case 5:
              if (!(message.request === 'relay peer message')) {
                _context8.n = 12;
                break;
              }
              relayed_tx = new Transaction(null, message.data); //
              // sanity check on tx
              //
              _context8.n = 6;
              return relayed_tx.decryptMessage(app);
            case 6:
              txjson = relayed_tx.returnMessage();
              if (this.debug) {
                console.log('Relay message: ', message);
                console.log('Relayed message : ', txjson);
              }
              if ((_relayed_tx$to$ = relayed_tx.to[0]) !== null && _relayed_tx$to$ !== void 0 && _relayed_tx$to$.publicKey) {
                _context8.n = 7;
                break;
              }
              return _context8.a(2, 0);
            case 7:
              //
              // if interior transaction is intended for me, I process regardless
              //
              if (this.debug) {
                console.log('relay tx to me? ' + relayed_tx.isTo(this.publicKey));
              }
              if (!relayed_tx.isTo(this.publicKey)) {
                _context8.n = 8;
                break;
              }
              return _context8.a(2, app.modules.handlePeerTransaction(relayed_tx, peer, mycallback));
            case 8:
              if (!(this.app.BROWSER == 0)) {
                _context8.n = 12;
                break;
              }
              // check to see if original tx is for a peer
              peer_found = 0;
              _context8.n = 9;
              return app.network.getPeers();
            case 9:
              peers = _context8.v;
              for (i = 0; i < peers.length; i++) {
                if (relayed_tx.isTo(peers[i].publicKey)) {
                  peer_found++;
                  app.network.sendTransactionWithCallback(relayed_tx, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                    return _regenerator().w(function (_context7) {
                      while (1) switch (_context7.n) {
                        case 0:
                          if (mycallback != null) {
                            mycallback({
                              err: '',
                              success: 1
                            });
                          }
                          return _context7.a(2, 1);
                      }
                    }, _callee7);
                  })), peers[i].publicKey)["catch"](function (err) {
                    console.error('relay forward failed', err);
                  });
                }
              }
              if (!(peer_found == 0)) {
                _context8.n = 11;
                break;
              }
              if (!(mycallback != null)) {
                _context8.n = 10;
                break;
              }
              mycallback({
                err: 'ERROR 141423: peer not found in relay module',
                success: 0
              });
              return _context8.a(2, 1);
            case 10:
              _context8.n = 12;
              break;
            case 11:
              console.info("Relay ".concat(txjson === null || txjson === void 0 ? void 0 : txjson.module, " tx to ").concat(peer_found, " peers"));
            case 12:
              _context8.n = 14;
              break;
            case 13:
              _context8.p = 13;
              _t = _context8.v;
              console.log(_t);
            case 14:
              return _context8.a(2, 0);
          }
        }, _callee8, this, [[2, 13]]);
      }));
      function handlePeerTransaction(_x1) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }]);
}(ModTemplate);
module.exports = Relay;